/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Full_Permissions_LabelInputs */

const en_team_share_full_permissions_label = /** @type {(inputs: Team_Share_Full_Permissions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full Permissions`)
};

const fr_team_share_full_permissions_label = /** @type {(inputs: Team_Share_Full_Permissions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autorisations complètes`)
};

const de_team_share_full_permissions_label = /** @type {(inputs: Team_Share_Full_Permissions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volle Berechtigungen`)
};

const it_team_share_full_permissions_label = /** @type {(inputs: Team_Share_Full_Permissions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permessi completi`)
};

const ru_team_share_full_permissions_label = /** @type {(inputs: Team_Share_Full_Permissions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Полные права доступа`)
};

const es_team_share_full_permissions_label = /** @type {(inputs: Team_Share_Full_Permissions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permisos completos`)
};

const zh_cn2_team_share_full_permissions_label = /** @type {(inputs: Team_Share_Full_Permissions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完全权限`)
};

const ja_team_share_full_permissions_label = /** @type {(inputs: Team_Share_Full_Permissions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完全な権限`)
};

const hi_team_share_full_permissions_label = /** @type {(inputs: Team_Share_Full_Permissions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूर्ण अनुमतियाँ`)
};

const pt_pt2_team_share_full_permissions_label = /** @type {(inputs: Team_Share_Full_Permissions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permissões totais`)
};

/**
* | output |
* | --- |
* | "Full Permissions" |
*
* @param {Team_Share_Full_Permissions_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_full_permissions_label = /** @type {((inputs?: Team_Share_Full_Permissions_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Full_Permissions_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_share_full_permissions_label(inputs)
	if (locale === "de") return de_team_share_full_permissions_label(inputs)
	if (locale === "it") return it_team_share_full_permissions_label(inputs)
	if (locale === "ru") return ru_team_share_full_permissions_label(inputs)
	if (locale === "es") return es_team_share_full_permissions_label(inputs)
	if (locale === "zh-CN") return zh_cn2_team_share_full_permissions_label(inputs)
	if (locale === "ja") return ja_team_share_full_permissions_label(inputs)
	if (locale === "hi") return hi_team_share_full_permissions_label(inputs)
	if (locale === "pt-PT") return pt_pt2_team_share_full_permissions_label(inputs)
	return en_team_share_full_permissions_label(inputs)
});